var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-modal",attrs:{"id":"AlertMessage"}},[_c('div',{staticClass:"alert-dialog"},[_c('div',{staticClass:"alert-content"},[_vm._t("title"),_vm._v(" "),_vm._t("text"),_vm._v(" "),_c('button',{staticClass:"btn btn-primario py-3",on:{"click":_vm.clickConfirm}},[_vm._v("OK")])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ff787f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/AlertMessage.vue
// module id = 1782
// module chunks = 5